// UI strings for the be.found.as editor, keyed by the English source string.
// Missing keys fall back to English.
const it: Record<string, string> = {
  "+ Add cover photo": "+ Aggiungi foto di copertina",
  "1 Rue de Rivoli, Paris": "Via Roma 1, Milano",
  "A bare domain can't use a CNAME, so it takes two steps. First, if your DNS provider offers an ALIAS or ANAME record (or CNAME flattening), point {domain} at this name — we keep it aimed at our servers, so it never needs updating:":
    "Un dominio radice non può usare un CNAME, quindi servono due passaggi. Primo: se il tuo provider DNS offre un record ALIAS o ANAME (o il CNAME flattening), fai puntare {domain} a questo nome — lo teniamo noi puntato ai nostri server, così non va mai aggiornato:",
  "A domain you own can show this page. Your found.as address keeps working — the domain is an extra way in, and you can remove it anytime.":
    "Un dominio di tua proprietà può mostrare questa pagina. Il tuo indirizzo found.as continua a funzionare — il dominio è una via d'accesso in più e puoi rimuoverlo quando vuoi.",
  "A line or two of text": "Una o due righe di testo",
  Accent: "Accento",
  "Accent color — left/right arrows change the hue, up/down how colorful":
    "Colore accento — le frecce sinistra/destra cambiano la tonalità, su/giù quanto è colorato",
  Access: "Accesso",
  "Add a name, photo, description, or link.":
    "Aggiungi un nome, una foto, una descrizione o un link.",
  "Add a video link.": "Aggiungi un link video.",
  "Add an image": "Aggiungi un'immagine",
  "Add photo": "Aggiungi foto",
  "Add row": "Aggiungi riga",
  "Add to your page": "Aggiungi alla tua pagina",
  Address: "Indirizzo",
  Advanced: "Avanzate",
  "Advanced format": "Formato avanzato",
  "Allow access": "Consenti l'accesso",
  "Allow pop-ups to open the print page.":
    "Consenti i pop-up per aprire la pagina di stampa.",
  "Any family from the {catalog}. Google is never involved.":
    "Qualsiasi famiglia dal {catalog}. Google non è mai coinvolto.",
  Authorize: "Autorizza",
  Auto: "Automatico",
  "Auto follows each visitor's device":
    "Automatico segue il dispositivo di ogni visitatore",
  "Auto follows each visitor's device — check both looks here":
    "Automatico segue il dispositivo di ogni visitatore — controlla qui entrambi gli aspetti",
  "Automatic preview image": "Immagine di anteprima automatica",
  Background: "Sfondo",
  "Blank password — anyone who opens this editor address can change your page.":
    "Password vuota — chiunque apra questo indirizzo dell'editor può modificare la tua pagina.",
  "Blur behind": "Sfocatura dietro",
  "Button text": "Testo dei pulsanti",
  "Button transparency": "Trasparenza dei pulsanti",
  Buttons: "Pulsanti",
  "Can't sign in": "Impossibile accedere",
  Cancel: "Annulla",
  Canvas: "Tela",
  "Cards & poster": "Biglietti e poster",
  "Change address": "Cambia indirizzo",
  "Change password": "Cambia password",
  "Check now": "Controlla ora",
  "Checking availability…": "Verifica disponibilità…",
  "Checking this sign-in request…": "Verifica della richiesta di accesso…",
  "Choose a file under 5MB.": "Scegli un file sotto i 5MB.",
  Circle: "Cerchio",
  Close: "Chiudi",
  Colors: "Colori",
  Connect: "Collega",
  Contact: "Contatti",
  "Contact buttons": "Pulsanti di contatto",
  "Contact card": "Scheda contatto",
  "Contact page": "Pagina di contatto",
  "Contact page editor": "Editor della pagina di contatto",
  Content: "Contenuti",
  Continue: "Continua",
  "Continue as {identity}": "Continua come {identity}",
  "Copied as plain text": "Copiato come testo semplice",
  "Copied ✓": "Copiato ✓",
  Copy: "Copia",
  "Copy link": "Copia link",
  "Copy plain text": "Copia testo semplice",
  "Copy signature": "Copia firma",
  "Copy {type} value": "Copia il valore {type}",
  "Copy, then paste into your email app's signature settings.":
    "Copia, poi incolla nelle impostazioni della firma della tua app e-mail.",
  Corners: "Angoli",
  "Could not compress that image.": "Impossibile comprimere l'immagine.",
  "Could not prepare the icon.": "Impossibile preparare l'icona.",
  "Could not prepare the image.": "Impossibile preparare l'immagine.",
  "Could not read that icon.": "Impossibile leggere quell'icona.",
  "Could not read that image.": "Impossibile leggere quell'immagine.",
  "Could not read the image.": "Impossibile leggere l'immagine.",
  "Couldn't render the social preview image — publishing the page without it.":
    "Impossibile generare l'immagine di anteprima social — la pagina viene pubblicata senza.",
  Cover: "Copertina",
  "Choose a password": "Scegli una password",
  "Create page": "Crea pagina",
  "Cropped to 1200×630 and served with your page. Until you add one, links share without an image.":
    "Ritagliata a 1200×630 e servita con la tua pagina. Finché non ne aggiungi una, i link vengono condivisi senza immagine.",
  "Custom link": "Link personalizzato",
  "Custom preview image": "Immagine di anteprima personalizzata",
  "Custom preview image that will be published":
    "Immagine di anteprima personalizzata che verrà pubblicata",
  Dark: "Scuro",
  "Darken by": "Scurisci di",
  "Delete page": "Elimina pagina",
  "Delete permanently": "Elimina definitivamente",
  "Design sections": "Sezioni di design",
  "Domain you own": "Dominio di tua proprietà",
  Dots: "Punti",
  "Drag to reorder": "Trascina per riordinare",
  "Drag to resize the preview": "Trascina per ridimensionare l'anteprima",
  "Edit page": "Modifica pagina",
  Email: "E-mail",
  "Email signature": "Firma e-mail",
  "Emoji icon": "Icona emoji",
  "Enter a Bluesky handle or link.": "Inserisci un handle o un link Bluesky.",
  "Enter a Bluesky handle.": "Inserisci un handle Bluesky.",
  "Enter a Cash App cashtag or link.":
    "Inserisci un cashtag o un link Cash App.",
  "Enter a Cash App cashtag.": "Inserisci un cashtag Cash App.",
  "Enter a Mastodon address or link.":
    "Inserisci un indirizzo o un link Mastodon.",
  "Enter a Matrix ID or link.": "Inserisci un ID o un link Matrix.",
  "Enter a Substack name or link.": "Inserisci un nome o un link Substack.",
  "Enter a WhatsApp phone number.": "Inserisci un numero di telefono WhatsApp.",
  "Enter a YouTube, Vimeo, or PeerTube link.":
    "Inserisci un link YouTube, Vimeo o PeerTube.",
  "Enter a domain like yourname.com.":
    "Inserisci un dominio come yourname.com.",
  "Enter a phone number.": "Inserisci un numero di telefono.",
  "Enter a redirect destination before publishing.":
    "Inserisci una destinazione di reindirizzamento prima di pubblicare.",
  "Enter a valid Bluesky link.": "Inserisci un link Bluesky valido.",
  "Enter a valid Cash App link.": "Inserisci un link Cash App valido.",
  "Enter a valid Mastodon link.": "Inserisci un link Mastodon valido.",
  "Enter a valid Matrix link.": "Inserisci un link Matrix valido.",
  "Enter a valid Substack link.": "Inserisci un link Substack valido.",
  "Enter a valid email address.": "Inserisci un indirizzo e-mail valido.",
  "Enter a valid map link.": "Inserisci un link mappa valido.",
  "Enter a valid redirect destination before publishing.":
    "Inserisci una destinazione di reindirizzamento valida prima di pubblicare.",
  "Enter a valid web address.": "Inserisci un indirizzo web valido.",
  "Enter a valid {label} link.": "Inserisci un link {label} valido.",
  "Enter a valid {service} link.": "Inserisci un link {service} valido.",
  "Enter a {label} link.": "Inserisci un link {label}.",
  "Enter a {service} username or link.":
    "Inserisci un nome utente o un link {service}.",
  "Enter a {service} username.": "Inserisci un nome utente {service}.",
  "Enter an Instagram username or link.":
    "Inserisci un nome utente o un link Instagram.",
  "Enter an address or map link.": "Inserisci un indirizzo o un link mappa.",
  "Enter an email address.": "Inserisci un indirizzo e-mail.",
  "Enter an https:// {label} link.": "Inserisci un link {label} https://.",
  "Enter the existing password": "Inserisci la password esistente",
  "Export backup (.zip)": "Esporta backup (.zip)",
  Fallback: "Riserva",
  "Favicon emoji": "Emoji della favicon",
  "Feature this link": "Metti in evidenza questo link",
  Featured: "In evidenza",
  "Featured — hidden until complete.":
    "In evidenza — nascosto finché non è completo.",
  "File to publish": "File da pubblicare",
  Fill: "Riempi",
  Filled: "Pieno",
  "Finish the Instagram link or username.":
    "Completa il link o il nome utente Instagram.",
  "Finish the {label} link.": "Completa il link {label}.",
  "Fit whole image": "Adatta l'immagine intera",
  Forget: "Dimentica",
  "Forget on this device": "Dimentica su questo dispositivo",
  "Format the text": "Formatta il testo",
  "Found it! Securing {domain} — this usually takes under a minute…":
    "Trovato! Stiamo proteggendo {domain} — di solito ci vuole meno di un minuto…",
  "Google Fonts catalog ↗": "catalogo Google Fonts ↗",
  "Google review": "Recensione Google",
  Gradient: "Sfumatura",
  Grid: "Griglia",
  "HTML content": "Contenuto HTML",
  Heading: "Intestazione",
  Height: "Altezza",
  "Hidden until complete.": "Nascosto finché non è completo.",
  "Hidden until it has text.": "Nascosto finché non ha testo.",
  "Hidden.": "Nascosto.",
  Hide: "Nascondi",
  "Host one file up to 5MB.": "Ospita un file fino a 5MB.",
  "Icon lookup failed ({status}).":
    "Ricerca dell'icona non riuscita ({status}).",
  "Icon saved into your page.": "Icona salvata nella tua pagina.",
  Image: "Immagine",
  "Import backup": "Importa backup",
  "Import icon": "Importa icona",
  "Imported — review and publish to make it live.":
    "Importato — controlla e pubblica per metterlo online.",
  "Importing…": "Importazione…",
  "In your Google Business Profile, use “Ask for reviews” to copy your review link — it looks like":
    "Nel tuo Profilo dell'attività su Google, usa “Richiedi recensioni” per copiare il link della recensione — è simile a",
  "Include on business cards": "Includi sui biglietti da visita",
  Language: "Lingua",
  "Lets visitors download a contact card (.vcf). It appears once the page has a name and a shown phone or email.":
    "Permette ai visitatori di scaricare una scheda contatto (.vcf). Compare quando la pagina ha un nome e un telefono o un'e-mail visibili.",
  Light: "Chiaro",
  "Lighten by": "Schiarisci di",
  "Links for web, email, social, phone, and more.":
    "Link per web, e-mail, social, telefono e altro.",
  "Loading…": "Caricamento…",
  Looks: "Aspetto",
  "Lowercase letters, numbers and hyphens make the best address — capitals and special characters are harder to type and share.":
    "Lettere minuscole, numeri e trattini fanno l'indirizzo migliore — maiuscole e caratteri speciali sono più difficili da digitare e condividere.",
  "Main address": "Indirizzo principale",
  "Manage domains": "Gestisci i domini",
  "Markdown content": "Contenuto Markdown",
  "Markdown: {bold}, {italic}, links, lists and headings.":
    "Markdown: {bold}, {italic}, link, elenchi e intestazioni.",
  "Mathematician · first computer programmer":
    "Matematica · prima programmatrice informatica",
  "Move page": "Sposta pagina",
  "Move {label} down": "Sposta {label} giù",
  "Move {label} up": "Sposta {label} su",
  Name: "Nome",
  "Need a public email address? Create a forwarding alias at":
    "Ti serve un indirizzo e-mail pubblico? Crea un alias di inoltro su",
  "New address": "Nuovo indirizzo",
  "New page path": "Nuovo percorso della pagina",
  "New password": "Nuova password",
  "No ALIAS support? Use a subdomain like {www} instead — it takes a plain CNAME.":
    "Niente supporto ALIAS? Usa invece un sottodominio come {www} — basta un semplice CNAME.",
  "No contact buttons yet.": "Ancora nessun pulsante di contatto.",
  "No icon found for that site.": "Nessuna icona trovata per quel sito.",
  "No priv.cbor found in this file.":
    "Nessun priv.cbor trovato in questo file.",
  None: "Nessuno",
  "Not a ZIP file.": "Non è un file ZIP.",
  "Now at found.as/{target}.": "Ora su found.as/{target}.",
  "On a subdomain instead (like www.{domain})?":
    "Preferisci un sottodominio (come www.{domain})?",
  "One CNAME on {domain} pointing to the address above. It connects the domain and proves it's yours in a single record.":
    "Un solo CNAME su {domain} che punta all'indirizzo qui sopra. Collega il dominio e dimostra che è tuo con un unico record.",
  "Online in seconds": "Online in pochi secondi",
  Open: "Apri",
  "Open your public page": "Apri la tua pagina pubblica",
  "Optional line under the button": "Riga facoltativa sotto il pulsante",
  "Or upload a separate dark image": "Oppure carica un'immagine scura separata",
  Outline: "Contorno",
  "Page link": "Link della pagina",
  "Page password": "Password della pagina",
  "Page path": "Percorso della pagina",
  "Page preview": "Anteprima della pagina",
  "Page type": "Tipo di pagina",
  "Password changed — save a fresh recovery kit.":
    "Password cambiata — salva un nuovo kit di recupero.",
  "Paste a valid Google review link.":
    "Incolla un link di recensione Google valido.",
  "Paste your Google review link.": "Incolla il tuo link di recensione Google.",
  Phone: "Telefono",
  "Photo shape": "Forma della foto",
  "Pick an address and a password. No account, no cookies.":
    "Scegli un indirizzo e una password. Niente account, niente cookie.",
  Pill: "Pillola",
  Platforms: "Piattaforme",
  "Preparing…": "Preparazione…",
  Preview: "Anteprima",
  "Preview appearance": "Aspetto dell'anteprima",
  "Preview description": "Descrizione dell'anteprima",
  "Preview fallback": "Anteprima di riserva",
  "Preview image appearance": "Aspetto dell'immagine di anteprima",
  "Preview image that will be published":
    "Immagine di anteprima che verrà pubblicata",
  "Preview title": "Titolo dell'anteprima",
  "Profile email": "E-mail del profilo",
  Publish: "Pubblica",
  "Publish a custom HTML page.": "Pubblica una pagina HTML personalizzata.",
  "Publish to {host}": "Pubblica su {host}",
  "QR code type": "Tipo di codice QR",
  Redirect: "Reindirizzamento",
  "Redirect destination": "Destinazione del reindirizzamento",
  "Redirect, markdown page, HTML page, or file.":
    "Reindirizzamento, pagina Markdown, pagina HTML o file.",
  "Refresh icon": "Aggiorna icona",
  "Remember on this device": "Ricorda su questo dispositivo",
  "Remembered on this device": "Ricordato su questo dispositivo",
  Remove: "Rimuovi",
  "Remove dark image": "Rimuovi immagine scura",
  "Remove icon": "Rimuovi icona",
  "Remove {label}": "Rimuovi {label}",
  Replace: "Sostituisci",
  "Replace dark image": "Sostituisci immagine scura",
  "Replace image": "Sostituisci immagine",
  Rounded: "Arrotondato",
  "Rounded square": "Quadrato arrotondato",
  Save: "Salva",
  "Save QR": "Salva QR",
  "Save QR code": "Salva codice QR",
  "Save contact": "Salva contatto",
  "Save contact button label": "Etichetta del pulsante Salva contatto",
  "Save recovery kit": "Salva il kit di recupero",
  "Saves this page's key in this browser so future sign-ins skip the password. Only on a device you trust.":
    "Salva la chiave di questa pagina in questo browser, così i prossimi accessi saltano la password. Solo su un dispositivo di cui ti fidi.",
  "Saves this page's key in this browser so it opens without the password. Only on a device you trust.":
    "Salva la chiave di questa pagina in questo browser, così si apre senza password. Solo su un dispositivo di cui ti fidi.",
  "Search fonts…": "Cerca font…",
  "Section header": "Intestazione di sezione",
  "Send visitors to one web address.": "Manda i visitatori a un indirizzo web.",
  Share: "Condividi",
  Sharing: "Condivisione",
  Sharp: "Netti",
  "Short description": "Descrizione breve",
  Show: "Mostra",
  "Show an icon on this button — type an emoji, or import the site's icon. It's fetched once and saved into your page.":
    "Mostra un'icona su questo pulsante — digita un'emoji o importa l'icona del sito. Viene scaricata una volta e salvata nella tua pagina.",
  "Show an icon on this button — type any emoji.":
    "Mostra un'icona su questo pulsante — digita un'emoji qualsiasi.",
  "Show on page": "Mostra sulla pagina",
  "Shown as a heading.": "Mostrato come intestazione.",
  "Shown as a video.": "Mostrato come video.",
  "Shown as text.": "Mostrato come testo.",
  "Shown in the browser tab.": "Mostrato nella scheda del browser.",
  "Sign in": "Accedi",
  "Sign in wherever you manage {domain}'s DNS — usually where you bought it — and add a CNAME record:":
    "Accedi dove gestisci i DNS di {domain} — di solito dove l'hai comprato — e aggiungi un record CNAME:",
  "Sign-in": "Accesso",
  "Signature preview": "Anteprima della firma",
  "Signing in…": "Accesso in corso…",
  Soft: "Morbidi",
  "Start writing GitHub-flavored markdown.\n\nOptional front matter:\n---\ntitle: Page title\n---":
    "Inizia a scrivere markdown in stile GitHub.\n\nFront matter facoltativo:\n---\ntitle: Titolo della pagina\n---",
  "Start writing HTML": "Inizia a scrivere HTML",
  "Status line": "Riga di stato",
  Style: "Stile",
  Subtitle: "Sottotitolo",
  System: "Sistema",
  "TXT record": "Record TXT",
  Text: "Testo",
  "That file is over 5MB. Choose a smaller file.":
    "Il file supera i 5MB. Scegli un file più piccolo.",
  "That icon is too large.": "L'icona è troppo grande.",
  "That password doesn't match this page.":
    "La password non corrisponde a questa pagina.",
  "That site did not return an icon.": "Il sito non ha restituito un'icona.",
  "The address featured on your QR code, printables and email signature. Your page stays reachable at every address either way.":
    "L'indirizzo in evidenza su codice QR, stampabili e firma e-mail. In ogni caso la tua pagina resta raggiungibile a ogni indirizzo.",
  Theme: "Tema",
  "Theme default": "Predefinito del tema",
  "Then add this record so we know the domain is yours:":
    "Poi aggiungi questo record così sappiamo che il dominio è tuo:",
  "There is no password reset. Once you're in, save the recovery kit from the menu — it keeps your address and password somewhere safe.":
    "Non esiste il ripristino della password. Una volta dentro, salva il kit di recupero dal menu — conserva il tuo indirizzo e la tua password al sicuro.",
  "This address already exists — password unlocked. Continue to edit it.":
    "Questo indirizzo esiste già — password sbloccata. Continua per modificarlo.",
  "This address exists. Enter its password to edit, or pick another address.":
    "Questo indirizzo esiste. Inserisci la sua password per modificarlo, oppure scegline un altro.",
  "This address isn't a found.as page.":
    "Questo indirizzo non è una pagina found.as.",
  "This domain is already connected to another page.":
    "Questo dominio è già collegato a un'altra pagina.",
  "This is really me": "Sono davvero io",
  "This permanently removes found.as/{path} and releases any custom domains. There's no undo.":
    "Questo rimuove definitivamente found.as/{path} e libera gli eventuali domini personalizzati. Non si può annullare.",
  "This replaces your page's key, so any recovery kit you've saved stops working — save a fresh one afterwards.":
    "Questo sostituisce la chiave della tua pagina, quindi qualsiasi kit di recupero salvato smette di funzionare — salvane uno nuovo subito dopo.",
  "This sign-in request is missing required details.":
    "A questa richiesta di accesso mancano dettagli obbligatori.",
  "This sign-in request isn't supported.":
    "Questa richiesta di accesso non è supportata.",
  "Type {path} to confirm": "Digita {path} per confermare",
  "Update password": "Aggiorna password",
  "Upload an image": "Carica un'immagine",
  "Use @you:server.org, or paste a matrix.to link.":
    "Usa @you:server.org oppure incolla un link matrix.to.",
  "Use @you@server, or paste your profile link.":
    "Usa @you@server oppure incolla il link del tuo profilo.",
  "Use the cover as the page's name": "Usa la copertina come nome della pagina",
  "Use this to edit later": "Ti servirà per modificare in seguito",
  "Using a bare domain like example.com?":
    "Usi un dominio radice come example.com?",
  "Video link": "Link video",
  "We check every few seconds — you can close this window and come back later.":
    "Controlliamo ogni pochi secondi — puoi chiudere questa finestra e tornare più tardi.",
  "We couldn't secure {domain} after repeated attempts. Remove it, check your DNS records, and try again.":
    "Non siamo riusciti a proteggere {domain} dopo vari tentativi. Rimuovilo, controlla i tuoi record DNS e riprova.",
  Website: "Sito web",
  "Which address an app receives when someone signs in with your page and allows the email permission.":
    "L'indirizzo che un'app riceve quando qualcuno accede con la tua pagina e consente il permesso e-mail.",
  Work: "Lavoro",
  "Working…": "Elaborazione…",
  "Works offline": "Funziona offline",
  "Write a simple page with Markdown.":
    "Scrivi una pagina semplice con Markdown.",
  "You're live 🎉": "Sei online 🎉",
  "Your HTML page is live.": "La tua pagina HTML è online.",
  "Your address": "Il tuo indirizzo",
  "Your contact page is live.": "La tua pagina di contatto è online.",
  "Your file is live.": "Il tuo file è online.",
  "Your markdown page is live.": "La tua pagina Markdown è online.",
  "Your page moves to the new address. The old one stops working, and any custom domains follow automatically.":
    "La tua pagina si sposta al nuovo indirizzo. Quello vecchio smette di funzionare e gli eventuali domini personalizzati la seguono automaticamente.",
  "Your page password": "La password della tua pagina",
  "Your password never leaves this device — it only signs the approval.":
    "La tua password non lascia mai questo dispositivo — firma soltanto l'approvazione.",
  "Your redirect is live.": "Il tuo reindirizzamento è online.",
  crimson: "cremisi",
  "e.g. New": "es. Nuovo",
  "e.g. ☕": "es. ☕",
  forest: "verde bosco",
  "found.as home — switch to another page":
    "home di found.as — passa a un'altra pagina",
  "found.as/{path} is available.": "found.as/{path} è disponibile.",
  gold: "oro",
  graphite: "grafite",
  "hue {hue}°, {pct}% colorful": "tonalità {hue}°, {pct}% colorato",
  live: "attivo",
  "needs attention": "richiede attenzione",
  ocean: "oceano",
  rust: "ruggine",
  "securing…": "protezione in corso…",
  "theme default": "predefinito del tema",
  violet: "viola",
  "youtube.com, vimeo.com, or a PeerTube link":
    "youtube.com, vimeo.com o un link PeerTube",
  "{client} wants to access your found.as page with these permissions:":
    "{client} vuole accedere alla tua pagina found.as con questi permessi:",
  "{client} wants to confirm you own this found.as page.":
    "{client} vuole confermare che questa pagina found.as è tua.",
  "{domain} isn't connected yet.": "{domain} non è ancora collegato.",
  "{index} of {total}": "{index} di {total}",
  "{link} is live.": "{link} è online.",
  "{name} is ready to publish.": "{name} è pronto per la pubblicazione.",
  "▶ Add a video": "▶ Aggiungi un video",
  "✓ We can see your proof record — now waiting for {domain} to route to us, usually just the DNS change spreading.":
    "✓ Vediamo il tuo record di verifica — ora aspettiamo che {domain} arrivi ai nostri server: di solito è solo la modifica DNS che si propaga.",
  "✓ {domain} is reaching us. Now add the record that proves it's yours — the {record} below.":
    "✓ {domain} ci raggiunge. Ora aggiungi il record che dimostra che è tuo — il {record} qui sotto.",
  "🟢 Status (optional)": "🟢 Stato (facoltativo)",
};

export default it;
